import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoMobileZephyrIcon } from '@ui/custom-icons';
import { env } from '@ui/environment';
const ENVIRONMENT_LOGO_VARIANTS = {
    local: {
        badgeLabel: 'dev',
        iconColor: 'var(--color-turquoise-300)',
        badgeClassName: 'border-turquoise-700 bg-turquoise-900 text-turquoise-300'
    },
    development: {
        badgeLabel: 'dev',
        iconColor: 'var(--color-turquoise-300)',
        badgeClassName: 'border-turquoise-700 bg-turquoise-900 text-turquoise-300'
    },
    preview: {
        badgeLabel: 'stg',
        iconColor: 'var(--color-blue-200)',
        badgeClassName: 'border-blue-500 bg-blue-800 text-blue-200'
    },
    prerelease: {
        badgeLabel: 'stg',
        iconColor: 'var(--color-blue-200)',
        badgeClassName: 'border-blue-500 bg-blue-800 text-blue-200'
    },
    production: null
};
export function EnvironmentLogo() {
    const variant = ENVIRONMENT_LOGO_VARIANTS[env.PUBLIC_ENV];
    if (!variant) {
        return /*#__PURE__*/ _jsx(LogoMobileZephyrIcon, {});
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "inline-flex items-center gap-1.5",
        "aria-label": "".concat(variant.badgeLabel, " environment"),
        children: [
            /*#__PURE__*/ _jsx(LogoMobileZephyrIcon, {
                color: variant.iconColor
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold leading-none lowercase ".concat(variant.badgeClassName),
                children: variant.badgeLabel
            })
        ]
    });
}
